import { useEffect } from 'react';
import { NON_DIGIKEY } from '../constants';

const useActiveStateTabHeader = (
  havePinOuts: boolean,
  haveBasePart: boolean,
  showTabHeader: boolean,
  checkFetchedUser: any,
  reverseSearchedProduct: any,
  isFetching: boolean,
  inputError: string,
  isNoProductFound: boolean,
  isNoCrossesFound: boolean
) => {
  useEffect(() => {
    const tabDisablePinouts = document.getElementById('tabComparePinouts');
    const tabDisableBasePart = document.getElementById('tabBasePart');
    const tabDisableReverseLookup = document.getElementById('tabReverseLookup');

    if (tabDisablePinouts) {
      // ! if part has base part
      if (havePinOuts) {
        tabDisablePinouts.style.pointerEvents = 'auto';
        tabDisablePinouts.style.opacity = '1';
      } else {
        tabDisablePinouts.style.pointerEvents = '';
        tabDisablePinouts.style.opacity = '';
      }
    }

    if (tabDisableBasePart) {
      // ! if part has base part
      if (haveBasePart) {
        tabDisableBasePart.style.pointerEvents = 'auto';
        tabDisableBasePart.style.opacity = '1';
      } else {
        tabDisableBasePart.style.pointerEvents = '';
        tabDisableBasePart.style.opacity = '';
      }
    }

    if (tabDisableReverseLookup) {
      // ! if input search is not null and part is non digikey type
      if (
        (!isNoProductFound || isNoCrossesFound) &&
        reverseSearchedProduct &&
        !isFetching &&
        reverseSearchedProduct[0].type !== NON_DIGIKEY &&
        !inputError
      ) {
        tabDisableReverseLookup.style.pointerEvents = 'auto';
        tabDisableReverseLookup.style.opacity = '1';
      } else {
        tabDisableReverseLookup.style.pointerEvents = '';
        tabDisableReverseLookup.style.opacity = '';
      }
    }
  }, [
    havePinOuts,
    haveBasePart,
    showTabHeader,
    checkFetchedUser,
    reverseSearchedProduct,
    isFetching,
    inputError,
    isNoProductFound,
    isNoCrossesFound
  ]);
};
export default useActiveStateTabHeader;
